import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message, Modal } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const SAVE_BARCODE_PRODUCT_REQUEST =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_REQUEST'
const SAVE_BARCODE_PRODUCT_SUCCESS =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_SUCCESS'
const SAVE_BARCODE_PRODUCT_FAILURE =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_FAILURE'

const SAVE_BARCODE_PRODUCT_FEATURE_REQUEST =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_FEATURE_REQUEST'
const SAVE_BARCODE_PRODUCT_FEATURE_SUCCESS =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_FEATURE_SUCCESS'
const SAVE_BARCODE_PRODUCT_FEATURE_FAILURE =
  'BarcodeProduct/SAVE_BARCODE_PRODUCT_FEATURE_FAILURE'

const GET_BARCODE_BY_ID_REQUEST = 'BarcodeProduct/GET_BARCODE_BY_ID_REQUEST'
const GET_BARCODE_BY_ID_SUCCESS = 'BarcodeProduct/GET_BARCODE_BY_ID_SUCCESS'
const GET_BARCODE_BY_ID_FAILURE = 'BarcodeProduct/GET_BARCODE_BY_ID_FAILURE'

const GET_BARCODE_RECYCLE_BY_ID_REQUEST =
  'BarcodeProduct/GET_BARCODE_RECYCLE_BY_ID_REQUEST'
const GET_BARCODE_RECYCLE_BY_ID_SUCCESS =
  'BarcodeProduct/GET_BARCODE_RECYCLE_BY_ID_SUCCESS'
const GET_BARCODE_RECYCLE_BY_ID_FAILURE =
  'BarcodeProduct/GET_BARCODE_RECYCLE_BY_ID_FAILURE'

const GET_BARCODE_PRODUCT_REQUEST = 'BarcodeProduct/GET_BARCODE_PRODUCT_REQUEST'
const GET_BARCODE_PRODUCT_SUCCESS = 'BarcodeProduct/GET_BARCODE_PRODUCT_SUCCESS'
const GET_BARCODE_PRODUCT_FAILURE = 'BarcodeProduct/GET_BARCODE_PRODUCT_FAILURE'

const GET_RECYCLE_BARCODE_PRODUCT_REQUEST =
  'BarcodeProduct/GET_RECYCLE_BARCODE_PRODUCT_REQUEST'
const GET_RECYCLE_BARCODE_PRODUCT_SUCCESS =
  'BarcodeProduct/GET_RECYCLE_BARCODE_PRODUCT_SUCCESS'
const GET_RECYCLE_BARCODE_PRODUCT_FAILURE =
  'BarcodeProduct/GET_RECYCLE_BARCODE_PRODUCT_FAILURE'

const DELETE_BARCODE_BY_ID_REQUEST =
  'BarcodeProduct/DELETE_BARCODE_BY_ID_REQUEST'
const DELETE_BARCODE_BY_ID_SUCCESS =
  'BarcodeProduct/DELETE_BARCODE_BY_ID_SUCCESS'
const DELETE_BARCODE_BY_ID_FAILURE =
  'BarcodeProduct/DELETE_BARCODE_BY_ID_FAILURE'

const DELETE_BARCODE_BRAND_REQUEST =
  'BarcodeProduct/DELETE_BARCODE_BRAND_REQUEST'
const DELETE_BARCODE_BRAND_SUCCESS =
  'BarcodeProduct/DELETE_BARCODE_BRAND_SUCCESS'
const DELETE_BARCODE_BRAND_FAILURE =
  'BarcodeProduct/DELETE_BARCODE_BRAND_FAILURE'

const GET_BARCODE_RECYCLE_ITEM_BY_ID_REQUEST =
  'BarcodeProduct/GET_BARCODE_RECYCLE__ITEM_BY_ID_REQUEST'
const GET_BARCODE_RECYCLE_ITEM_BY_ID_SUCCESS =
  'BarcodeProduct/GET_BARCODE_RECYCLE__ITEM_BY_ID_SUCCESS'
const GET_BARCODE_RECYCLE_ITEM_BY_ID_FAILURE =
  'BarcodeProduct/GET_BARCODE_RECYCLE__ITEM_BY_ID_FAILURE'

const UPDATE_BARCODE_RECYCLE_ITEM_REQUEST =
  'BarcodeProduct/UPDATE_BARCODE_RECYCLE_ITEM_REQUEST'
const UPDATE_BARCODE_RECYCLE_ITEM_SUCCESS =
  'BarcodeProduct/UPDATE_BARCODE_RECYCLE_ITEM_SUCCESS'
const UPDATE_BARCODE_RECYCLE_ITEM_FAILURE =
  'BarcodeProduct/UPDATE_BARCODE_RECYCLE_ITEM_FAILURE'

const DELETE_RECYCLE_BARCODE_PRODUCT_REQUEST =
  'BarcodeProduct/DELETE_RECYCLE_BARCODE_PRODUCT_REQUEST'
const DELETE_RECYCLE_BARCODE_PRODUCT_SUCCESS =
  'BarcodeProduct/DELETE_RECYCLE_BARCODE_PRODUCT_SUCCESS'
const DELETE_RECYCLE_BARCODE_PRODUCT_FAILURE =
  'BarcodeProduct/DELETE_RECYCLE_BARCODE_PRODUCT_FAILURE'

const GET_BARCODE_PRODUCT_CATEGORY_REQUEST = 'BarcodeProduct/GET_BARCODE_PRODUCT_CATEGORY_REQUEST'
const GET_BARCODE_PRODUCT_CATEGORY_SUCCESS = 'BarcodeProduct/GET_BARCODE_PRODUCT_CATEGORY_SUCCESS'
const GET_BARCODE_PRODUCT_CATEGORY_FAILURE = 'BarcodeProduct/GET_BARCODE_PRODUCT_CATEGORY_FAILURE'

const SAVE_BARCODE_PRODUCT_CATEGORY_REQUEST = 'BarcodeProduct/SAVE_BARCODE_PRODUCT_CATEGORY_REQUEST'
const SAVE_BARCODE_PRODUCT_CATEGORY_SUCCESS = 'BarcodeProduct/SAVE_BARCODE_PRODUCT_CATEGORY_SUCCESS'
const SAVE_BARCODE_PRODUCT_CATEGORY_FAILURE = 'BarcodeProduct/SAVE_BARCODE_PRODUCT_CATEGORY_FAILURE'

const UPDATE_BARCODE_PRODUCT_CATEGORY_REQUEST = 'BarcodeProduct/UPDATE_BARCODE_PRODUCT_CATEGORY_REQUEST'
const UPDATE_BARCODE_PRODUCT_CATEGORY_SUCCESS = 'BarcodeProduct/UPDATE_BARCODE_PRODUCT_CATEGORY_SUCCESS'
const UPDATE_BARCODE_PRODUCT_CATEGORY_FAILURE = 'BarcodeProduct/UPDATE_BARCODE_PRODUCT_CATEGORY_FAILURE'

const DELETE_BARCODE_PRODUCT_CATEGORY_REQUEST = 'BarcodeProduct/DELETE_BARCODE_PRODUCT_CATEGORY_REQUEST'
const DELETE_BARCODE_PRODUCT_CATEGORY_SUCCESS = 'BarcodeProduct/DELETE_BARCODE_PRODUCT_CATEGORY_SUCCESS'
const DELETE_BARCODE_PRODUCT_CATEGORY_FAILURE = 'BarcodeProduct/DELETE_BARCODE_PRODUCT_CATEGORY_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  barcodeDetail: {},
  barcodeProductObj: {
    content: [],
    pageable: {}
  },
  recycleBarcodeProduct: {
    content: [],
    pageable: {}
  },
  recycleList: [],
  barcodeRecycleItems: [],
  barcodeCategory:[]
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_BARCODE_PRODUCT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_BARCODE_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_BARCODE_PRODUCT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case SAVE_BARCODE_PRODUCT_FEATURE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case SAVE_BARCODE_PRODUCT_FEATURE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case SAVE_BARCODE_PRODUCT_FEATURE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_BARCODE_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_BARCODE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        barcodeDetail: action.payload
      }
    case GET_BARCODE_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_BARCODE_PRODUCT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_BARCODE_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        barcodeProductObj: action.payload
      }
    case GET_BARCODE_PRODUCT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_RECYCLE_BARCODE_PRODUCT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_RECYCLE_BARCODE_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        recycleBarcodeProduct: action.payload
      }
    case GET_RECYCLE_BARCODE_PRODUCT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_BARCODE_RECYCLE_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_BARCODE_RECYCLE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        recycleList: action.payload
      }
    case GET_BARCODE_RECYCLE_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BARCODE_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BARCODE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BARCODE_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BARCODE_BRAND_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BARCODE_BRAND_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BARCODE_BRAND_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_BARCODE_RECYCLE_ITEM_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_BARCODE_RECYCLE_ITEM_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        barcodeRecycleItems: action.payload
      }
    case GET_BARCODE_RECYCLE_ITEM_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BARCODE_RECYCLE_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BARCODE_RECYCLE_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BARCODE_RECYCLE_ITEM_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_RECYCLE_BARCODE_PRODUCT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_RECYCLE_BARCODE_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_RECYCLE_BARCODE_PRODUCT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case GET_BARCODE_PRODUCT_CATEGORY_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case GET_BARCODE_PRODUCT_CATEGORY_SUCCESS:
        return {
          ...state,
          isLoading: false,
          barcodeCategory: action.payload
        }
      case GET_BARCODE_PRODUCT_CATEGORY_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
        case SAVE_BARCODE_PRODUCT_CATEGORY_REQUEST:
          return {
            ...state,
            isLoading: true
          }
        case SAVE_BARCODE_PRODUCT_CATEGORY_SUCCESS:
          return {
            ...state,
            isLoading: false
          }
        case SAVE_BARCODE_PRODUCT_CATEGORY_FAILURE:
          return {
            ...state,
            error: action.error,
            isLoading: false
          }
          case UPDATE_BARCODE_PRODUCT_CATEGORY_REQUEST:
            return {
              ...state,
              isLoading: true
            }
          case UPDATE_BARCODE_PRODUCT_CATEGORY_SUCCESS:
            return {
              ...state,
              isLoading: false
            }
          case UPDATE_BARCODE_PRODUCT_CATEGORY_FAILURE:
            return {
              ...state,
              error: action.error,
              isLoading: false
            }
          case DELETE_BARCODE_PRODUCT_CATEGORY_REQUEST:
            return {
              ...state,
              isLoading: true
            }
          case DELETE_BARCODE_PRODUCT_CATEGORY_SUCCESS:
            return {
              ...state,
              isLoading: false
            }
          case DELETE_BARCODE_PRODUCT_CATEGORY_FAILURE:
            return {
              ...state,
              error: action.error,
              isLoading: false
            }
    default:
      return state
  }
}

// Action Creators
export const saveBarcodeProduct = (data, action) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      await API.post(EndPoints.BARCODE + `/saveByAdmin`, data, {
        headers: {
          Authorization: userToken
        }
      })

      dispatch({
        type: SAVE_BARCODE_PRODUCT_SUCCESS
      })
      if (action === 'create') {
        Modal.success({
          title: 'เพิ่มข้อมูลเรียบร้อยแล้ว'
        })
      } else {
        Modal.success({
          title: 'แก้ไขข้อมูลเรียบร้อยแล้ว'
        })
      }
    } catch (err) {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_FAILURE
      })
    }
  }
}

export const saveBarcodeProductFeature = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_FEATURE_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      await API.post(EndPoints.BARCODE + `/saveProductFeature`, data, {
        headers: {
          Authorization: userToken
        }
      })

      dispatch({
        type: SAVE_BARCODE_PRODUCT_FEATURE_SUCCESS
      })
    } catch (err) {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_FEATURE_FAILURE
      })
    }
  }
}

export const getBarcodeById = (barcodeId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_BARCODE_BY_ID_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      const response = await API.get(
        EndPoints.BARCODE + `/adminDetail/${barcodeId}`,
        {
          headers: {
            Authorization: userToken
          }
        }
      )

      if (response.status === 200) {
        dispatch({
          type: GET_BARCODE_BY_ID_SUCCESS,
          payload: response.data
        })
      }
    } catch (err) {
      dispatch({
        type: GET_BARCODE_BY_ID_FAILURE
      })
    }
  }
}

export const getBarcodeRecycleByBarcodeId = (barcodeId, page) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_BARCODE_RECYCLE_BY_ID_REQUEST
      })
      const params = new URLSearchParams()
      params.append('productId', barcodeId)

      const response = await API.get(EndPoints.BARCODE + `/recycle-search`, {
        params: params
      })
      dispatch({
        type: GET_BARCODE_RECYCLE_BY_ID_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_BARCODE_RECYCLE_BY_ID_FAILURE
      })
    }
  }
}

export const getBarcodeProduct = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_BARCODE_PRODUCT_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      const response = await API.get(EndPoints.BARCODE + `/search`, {
        headers: {
          Authorization: userToken
        },
        params: options
      })

      dispatch({
        type: GET_BARCODE_PRODUCT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_BARCODE_PRODUCT_FAILURE
      })
    }
  }
}

export const getRecycleBarcodeProduct = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_RECYCLE_BARCODE_PRODUCT_REQUEST
      })
      const params = new URLSearchParams()
      if (options.createdBy) params.append('createdBy', options.createdBy)
      if (options.keyword) params.append('keyword', options.keyword)
      if (options.barcode) params.append('barcode', options.barcode)
      params.append('desc', options.desc)
      params.append('page', options.page)
      params.append('size', options.size)
      const materials = options.materials
      for (let i = 0; i < materials.length; i++) {
        params.append('materials', materials[i])
      }

      const response = await API.get(EndPoints.BARCODE + `/recycle-search`, {
        params: params
      })

      dispatch({
        type: GET_RECYCLE_BARCODE_PRODUCT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_RECYCLE_BARCODE_PRODUCT_FAILURE
      })
    }
  }
}

export const deleteBarcodeById = (barcodeId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BARCODE_BY_ID_REQUEST
      })

      const response = await API.delete(EndPoints.BARCODE + `/${barcodeId}`)

      if (response.status === 200) {
        dispatch({
          type: DELETE_BARCODE_BY_ID_SUCCESS
        })

        Modal.success({
          title: 'ลบข้อมูลเรียบร้อย'
        })
      }
    } catch (err) {
      dispatch({
        type: DELETE_BARCODE_BY_ID_FAILURE
      })
    }
  }
}

export const deleteBarcodeBrand = (barcodeId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BARCODE_BRAND_REQUEST
      })

      await API.delete(EndPoints.BARCODE + `/removeBrand/${barcodeId}`)
      dispatch({
        type: DELETE_BARCODE_BRAND_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BARCODE_BRAND_FAILURE
      })
    }
  }
}

export const getBarcodeRecycleItemByBarcodeProductId = (barcodeId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_BARCODE_RECYCLE_ITEM_BY_ID_REQUEST
      })

      const { data } = await API.get(
        EndPoints.BARCODE + `/${barcodeId}/barcode-recycle-item`
      )
      dispatch({
        type: GET_BARCODE_RECYCLE_ITEM_BY_ID_SUCCESS,
        payload: data
      })
    } catch (err) {
      dispatch({
        type: GET_BARCODE_RECYCLE_ITEM_BY_ID_FAILURE
      })
    }
  }
}

export const updateBarcodeRecycleItem = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BARCODE_RECYCLE_ITEM_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      const headers = {
        Authorization: userToken
      }
      await API.put(EndPoints.BARCODE + `/recycle-item`, data, {
        headers: headers
      })
      dispatch({
        type: UPDATE_BARCODE_RECYCLE_ITEM_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BARCODE_RECYCLE_ITEM_FAILURE
      })
    }
  }
}

export const deleteRecycleBarcodeProduct = (barcodeRecycleId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_RECYCLE_BARCODE_PRODUCT_REQUEST
      })

      await API.delete(
        EndPoints.BARCODE + `/recycle-barcode/${barcodeRecycleId}`
      )
      dispatch({
        type: DELETE_RECYCLE_BARCODE_PRODUCT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_RECYCLE_BARCODE_PRODUCT_FAILURE
      })
    }
  }
}
export const getBarcodeProductCategory = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_BARCODE_PRODUCT_CATEGORY_REQUEST
      })
      const response = await API.get(EndPoints.BARCODE + `/category`)

      dispatch({
        type: GET_BARCODE_PRODUCT_CATEGORY_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_BARCODE_PRODUCT_CATEGORY_FAILURE
      })
    }
  }
}
export const addBarcodeProductCategory = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_CATEGORY_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      const name = data.name
      await API.post(EndPoints.BARCODE + `/addBarcodeCategory`, null, {
        headers: {
          Authorization: userToken
        },
        params: {
          name: name
        }
      })

      dispatch({
        type: SAVE_BARCODE_PRODUCT_CATEGORY_SUCCESS
      })
    } catch (err) {
      dispatch({
        type: SAVE_BARCODE_PRODUCT_CATEGORY_FAILURE
      })
    }
  }
}
export const updateBarcodeProductCategory = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BARCODE_PRODUCT_CATEGORY_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      const id = data.id
      const name = data.name
      await API.put(EndPoints.BARCODE + `/updateBarcodeCategory`, null, {
        headers: {
          Authorization: userToken
        },
        params: {
          id : id,
          name: name
        }
      })

      dispatch({
        type: UPDATE_BARCODE_PRODUCT_CATEGORY_SUCCESS
      })
    } catch (err) {
      dispatch({
        type: UPDATE_BARCODE_PRODUCT_CATEGORY_FAILURE
      })
    }
  }
}
export const deleteBarcodeProductCategory = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BARCODE_PRODUCT_CATEGORY_REQUEST
      })
      const userToken = localStorage.getItem('user-token')
      await API.delete(
        EndPoints.BARCODE + `/category-barcode/${id}`, {
          headers: {
            Authorization: userToken
          }
        })
      dispatch({
        type: DELETE_BARCODE_PRODUCT_CATEGORY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BARCODE_PRODUCT_CATEGORY_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/barcodeProduct.js